import { matchPath } from "react-router";

interface ShellPage {
  path: string;
  name: string;
  /// Shorter, where the rail nests the item under a heading.
  railName?: string;
}

/// One table, so the rail and the back arrow can't name a page two ways.
export const SHELL_PAGES = {
  Overview: { path: "/overview", name: "Spaces" },
  SharedWithMe: { path: "/shared", name: "Shared with me" },
  Datasets: { path: "/datasets", name: "Datasets" },
  CatalogModels: { path: "/catalog/models", name: "Catalog models" },
  Recipes: { path: "/recipes", name: "Recipes" },
  Apps: { path: "/apps", name: "Apps" },
  Connections: { path: "/connections", name: "Connections" },
  Trash: { path: "/trash", name: "Trash" },
  Access: { path: "/access", name: "Access" },
  AdminInvitations: { path: "/admin/invitations", name: "Invitations" },
  AdminAccounts: { path: "/admin/accounts", name: "Accounts" },
  AdminOrganizations: { path: "/admin/organizations", name: "Organizations" },
  AdminRemovedAccounts: {
    path: "/admin/removed-accounts",
    name: "Removed accounts",
    railName: "Removed",
  },
  AdminServiceAccounts: {
    path: "/admin/service-accounts",
    name: "Service Accounts",
  },
  AdminModelProviders: {
    path: "/admin/model-providers",
    name: "Model providers",
  },
  AdminReleases: { path: "/admin/releases", name: "Releases" },
  AdminConsent: { path: "/admin/consent", name: "Terms & consent" },
  AdminDataLifecycle: { path: "/admin/data-lifecycle", name: "Data Lifecycle" },
  AdminAudit: { path: "/admin/audit", name: "Audit Tooling" },
} satisfies Record<string, ShellPage>;

export type ShellPageKey = keyof typeof SHELL_PAGES;

/// Shell pages the rail has no item for, most specific first.
const UNLISTED_PAGES: { pattern: string; name: string }[] = [
  { pattern: "/spaces/:space_id", name: "Space settings" },
  { pattern: "/apps/new", name: "New app" },
  { pattern: "/apps/new/design", name: "New design app" },
  { pattern: "/apps/new/research", name: "New research app" },
  { pattern: "/apps/:app_id", name: "App" },
  { pattern: "/organizations/new", name: "New organization" },
  { pattern: "/organizations/:org_id/created", name: "New organization" },
  { pattern: "/organizations/:org_id", name: "Organization settings" },
  { pattern: "/billing/welcome", name: "Billing" },
];

export function railName(key: ShellPageKey): string {
  const page: ShellPage = SHELL_PAGES[key];
  return page.railName ?? page.name;
}

export function shellPageName(pathname: string): string | null {
  const listed = Object.values(SHELL_PAGES).find(
    (page) => page.path === pathname,
  );
  if (listed) return listed.name;
  return (
    UNLISTED_PAGES.find(({ pattern }) => matchPath(pattern, pathname))?.name ??
    null
  );
}
